export default __webpack_public_path__ + "static/media/check-in-banner-cn.9972361a.webp";